/**
 * Remove slashes from the start and end of a string
 * @param {string} str
 * @return {string}
 */
function stripSlashes(str) {
	return str.replace(/(^\/+|\/+$)/g, '');
}

// The header nav and the phone menu get aria-current from the server
// (_markup/site/_nav.twig), which knows section aliases such as /ai-bath
// under "AI for business"; this leaves them alone.
const SERVER_NAV = '.site-nav a, .site-menu-nav a';

export default path => {
	[
		...document.querySelectorAll('a.is-active, a.is-current, a[aria-current]'),
	].forEach(link => {
		if (link.matches(SERVER_NAV)) return;
		link.classList.remove('is-current');
		link.removeAttribute('aria-current');
	});
	[...document.querySelectorAll('a')].forEach(link => {
		// Fragment links point at page sections, never at "the current
		// page" — without this, every hash link on the homepage matches '/'.
		// Deliberately broader than localLinks' pure-fragment startsWith('#')
		// guard: a `/path#hash` link is still local there, but must never
		// win aria-current here.
		if ((link.getAttribute('href') || '').includes('#')) return;
		if (link.matches(SERVER_NAV)) return;
		if (stripSlashes(link.pathname) === stripSlashes(path)) {
			link.classList.add('is-current');
			link.setAttribute('aria-current', 'page');

			// Activate parent link
			const linkParentLi = link.closest('[data-primary]');
			if (!linkParentLi) return;
			const linkParent = linkParentLi.querySelector('[data-parent]');
			if (!linkParent) return;
			linkParent.classList.add('is-current');
		}
	});
};
